<template>
  <div class="footer">
    <div class="footer-bg">
      <!-- <div class="padding-top-20"></div> -->
      <div class="address">
        {{footer.TECHNICAL_SUPPORT}} 版权所有 {{footer.COPYRIGHT_STARTYEAR}}-{{new Date().getFullYear()}}
         <!-- <a href="">{{footer.BEIAN_NO}}</a> -->
         <br>
        {{footer.COPYRIGHT_COMPANY_ADDRESS_HENAN}}
        <br>
        客服电话:{{footer.TECHNICAL_SUPPORT_TEL}}
        <br>
        <a href="https://beian.miit.gov.cn">{{footer.BEIAN_NO}}</a><br>
      </div>
      <!-- <div class="rn">
        <a href=""></a>
      </div> -->
      <!-- 二维码 -->
      <!-- <div class="qr"><img src="" width="120"></div> -->
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      footer: []
    }
  },
  mounted () {
    axios.get(`https://bidguamgt-product.oss-cn-beijing.aliyuncs.com/statics/json/configes.json`)
      .then(response => {
        this.footer = response.data.FOOTER
        // console.log(this.footer)
      })
  }
}
</script>

<style lang="less" scoped>
.footer {
  margin-top: 20px;
  padding: 0 10% 10px 10%;
  font-size: 14px;
  text-align: center;
  // width: 100%;
  // height: 150px;
  // position: relative;
  background-color: #f7f7f7;
  color: #5a5a5a;
  border-top: 1px solid #dadada;
  .address {
    padding: 20px 0 5px 0;
  }
  a {
    color: #a7a7a7;
    }
}
  // min-width: 1200px;
  // .qr {
  //   position: absolute;
  //   z-index: 2;
  //   right: 100px;
  //   top: 16px;
  // }
  // .footer-bg {
  //   display: flex;
  //   flex-direction: column;
  //   align-items: center;
  //   .footer-nav {
  //     & > ul {
  //       & > li {
  //         display: inline-block;
  //         font-size: 16px;
  //         line-height: 32px;
  //         margin: 10px 20px;
  //       }
  //     }
  //   }
  //   }
</style>



// WEBPACK FOOTER //
// src/components/footer.vue